import { IMenuOption } from "@/services/DTOs/Misc";
import { PermissionCategory } from "@/services/DTOs/Permission";

export default [
  {
    text: "Shared Balance",
    to: "/credits/balance",
    icon: "mdi-bank",
    permissions: [
      {
        name: "credits.balance",
        category: PermissionCategory.PAGE
      }
    ]
  },
  {
    text: "Add to Shared Balance",
    to: "/credits/add",
    icon: "mdi-cash-plus",
    permissions: [
      {
        name: "credits.add",
        category: PermissionCategory.PAGE
      }
    ]
  },
  {
    text: "Allocate to Reach",
    to: "/credits/spend",
    icon: "mdi-cash-minus",
    permissions: [
      {
        name: "credits.spend",
        category: PermissionCategory.PAGE
      }
    ]
  }
] as IMenuOption[];
